/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_New_Password_LabelInputs */

const en_password_reset_new_password_label = /** @type {(inputs: Password_Reset_New_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New password`)
};

const es_password_reset_new_password_label = /** @type {(inputs: Password_Reset_New_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva contraseña`)
};

/**
* | output |
* | --- |
* | "New password" |
*
* @param {Password_Reset_New_Password_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_new_password_label = /** @type {((inputs?: Password_Reset_New_Password_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_New_Password_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_new_password_label(inputs)
	return en_password_reset_new_password_label(inputs)
});